//#region Imports

import { Component, Input } from '@angular/core';
import { ButtonComponent } from "../button/button.component";
import { ButtonTypeEnum } from '../button/types/button-type.enum';
import { ButtonRadiusEnum } from '../button/types/button-radius.enum';
import { ButtonSizeEnum } from '../button/types/button-size.enum';

//#endregion

@Component({
  selector: 'l-progress-banner',
  standalone: true,
  templateUrl: './progress-banner.component.html',
  imports: [ButtonComponent],
})
export class ProgressBannerComponent {

  //#region Public Properties

  @Input()
  public progress: number = 0;

  public buttonTypeEnum: typeof ButtonTypeEnum = ButtonTypeEnum;

  public buttonRadiusEnum: typeof ButtonRadiusEnum = ButtonRadiusEnum;

  public buttonSizeEnum: typeof ButtonSizeEnum = ButtonSizeEnum;

  //#endregion

  //#region Getters

  public get normalizedProgress(): number {
    return Math.min(100, Math.max(0, this.progress ?? 0));
  }

  public get isCompleted(): boolean {
    return this.normalizedProgress >= 100;
  }

  public get progressText(): string {
    return `${this.normalizedProgress}%`;
  }

  public get ringBackground(): string {
    return `conic-gradient(var(--tenant-primary-color, #4A3AFF) ${this.normalizedProgress}%, rgb(113 119 139 / 45%) 0)`;
  }

  public get title(): string {
    return this.isCompleted
      ? 'Curso concluído com sucesso!'
      : `Você já concluiu ${this.progressText} do curso`;
  }

  public get subtitle(): string {
    return this.isCompleted
      ? 'Cada conquista te aproxima da sua melhor versão.'
      : 'Retome de onde parou e avance no seu ritmo.';
  }

  public get buttonLabel(): string {
    return this.isCompleted ? 'Download certificado' : 'Continuar aprendendo';
  }

  //#endregion

}
